import React from "react";
import { Box } from "@mui/material";
import { COLORS, CONTENT_MAX_WIDTH } from "../../shared/styles";

function RoutingRadio({ selected, onClick }) {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      aria-checked={selected}
      role="radio"
      sx={{
        width: 16,
        height: 16,
        borderRadius: "50px",
        border: `1px solid ${selected ? COLORS.primary : COLORS.border}`,
        bgcolor: COLORS.white,
        boxShadow: selected ? "0 1px 2px 0 rgba(20, 141, 253, 0.10)" : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        p: 0,
        cursor: "pointer",
        outline: "none",
        "&:focus-visible": {
          outline: `2px solid ${COLORS.primary}`,
          outlineOffset: 2,
        },
      }}
    >
      {selected ? (
        <Box
          sx={{
            width: 12,
            height: 12,
            borderRadius: "50%",
            bgcolor: COLORS.primary,
          }}
        />
      ) : null}
    </Box>
  );
}

export default RoutingRadio;
